import { resolveCartOptions, resolveCartRouteOptions } from "./utils.mjs";
import { useStoredCart } from "./storage.mjs";
import { CustomerCartDocument } from "../../graphql/Cart.mjs";
import { useChannels, topics } from "../channels.mjs";
import { isEmpty } from "lodash-es";
import { useQuery } from "villus";
import { useRoute, watch } from "#imports";
export function useCustomerCart() {
  const { execute, isFetching } = useQuery({
    query: CustomerCartDocument.toString(),
    fetchOnMount: false,
    cachePolicy: "network-only"
  });
  const route = useRoute();
  const { subscribe, unsubscribe } = useChannels();
  const { patchCartState, mapCartState, isFetchingCart } = useStoredCart();
  async function getCart(opts = {}) {
    const { data, error } = await execute({
      variables: {
        ...resolveCartOptions("customerCart"),
        ...opts
      }
    });
    if (error) {
      throw new Error(error.message);
    }
    if (data?.cart) {
      patchCartState(mapCartState(data?.cart));
    }
    const unwatch = watch(
      () => route.name,
      async (newRoute) => {
        const option = resolveCartRouteOptions("customerCart", newRoute);
        if (!isEmpty(option)) {
          await getCart(option);
          unwatch();
        }
      }
    );
    const cb = () => {
      if (process.client) {
        unwatch();
        unsubscribe(topics.auth.logout, cb);
      }
    };
    subscribe(topics.auth.logout, cb);
  }
  watch(isFetching, (value) => {
    isFetchingCart.value = value;
  });
  return {
    getCart
  };
}
